<template>
  <div class="flex flex-col gap-6 z-1000 w-full h-full">
    <loading-overlay v-if="loading" :value="loading" />
    <div v-else class="block-container">
      <BaseTabs :tabs="tabs" :active-tab="activeTab" @change:tab="changeTab">
        <template #action>
          <div
            v-if="$route.name !== 'benefit_item_view'"
            class="flex items-center gap-2"
          >
            <el-tooltip
              v-if="$route.name !== 'benefit_new'"
              :content="$t('Режим просмотра')"
              placement="top"
            >
              <Button variant="outline" size="icon" @click="goToView">
                <svg-icon name="huge-eye" class="w-4 h-4 text-foreground" />
              </Button>
            </el-tooltip>
            <Button variant="default" :disabled="loader" @click="submitForm">{{
              $t("Сохранить")
            }}</Button>
          </div>

          <div v-else class="flex items-center gap-3">
            <Button variant="outline" @click="goToEdit">
              <svg-icon name="huge-edit" class="w-4 h-4 text-foreground" />
            </Button>
          </div>
        </template>
      </BaseTabs>
    </div>

    <component
      :is="currentTabComponent"
      :form="form"
      :selected-tariff="selected_tariff"
      ref="activeForm"
      class="flex-1 w-full h-full"
    />
  </div>
</template>

<script>
import LoadingOverlay from "@/shared/ui/custom/components/LoadingOverlay.vue";
import BaseTabs from "@/shared/ui/custom/tabs/BaseTabs.vue";
import BenefitData from "@/pages/admin/tariffs/benefits/tabs/BenefitData.vue";
import Button from "@/shared/ui/button/Button.vue";
import {
  getTariffPreferentialItem,
  updatePreferentialTariff,
  createPreferentialTariff,
} from "@/entities/tariff";

export default {
  name: "TariffItem",
  components: {
    LoadingOverlay,
    BaseTabs,
    BenefitData,
    Button,
  },
  data() {
    return {
      loading: false,
      loader: false,
      activeTab: "data",
      selected_tariff: null,

      form: {
        codes: [],
        name: "",
        name_kz: "",
        name_en: "",
        discount_value: "",
        is_active: true,
      },
    };
  },
  async created() {
    if (this.uuid && this.uuid !== "new") {
      await this.getTariffPreferentialItem();
    }
  },
  computed: {
    tabs() {
      const tabs = {
        data: {
          label: this.$t("Параметры тарифа"),
          icon: "huge-text-config",
        },
      };

      return tabs;
    },

    uuid() {
      return this.$route.params.id;
    },

    currentTabComponent() {
      const tabComponents = {
        data: BenefitData,
      };

      return tabComponents[this.activeTab] || null;
    },
  },
  watch: {
    "$route.name"() {
      if (this.uuid && this.uuid !== "new") {
        this.getTariffPreferentialItem();
      }
    },
    "$route.query.tab": {
      immediate: true,
      handler(tab) {
        if (tab) {
          this.activeTab = tab;
        }
      },
    },
  },

  methods: {
    async getTariffPreferentialItem() {
      this.loading = true;

      try {
        let data = await getTariffPreferentialItem(this.uuid);
        if (data?.success) {
          if (data?.payload) {
            this.selected_tariff = data.payload;
          }

          this.form = {
            ...data?.payload,
          };
        }
      } finally {
        setTimeout(() => (this.loading = false), 500);
      }
    },
    changeTab(tab) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab,
        },
      });
    },
    goToView() {
      this.$router.push({
        name: "benefit_item_view",
        params: { id: this.uuid },
      });
    },
    goToEdit() {
      this.$router.push({
        name: "benefit_item",
        params: { id: this.uuid },
      });
    },
    async submitForm() {
      const formRef = this.$refs.activeForm;

      if (!formRef?.validate) return;

      const valid = await formRef.validate();

      if (!valid) {
        console.warn("❌ Validation failed");
        return;
      }

      const payload = { ...this.form };

      if (this.uuid && this.uuid !== "new") {
        await this.updatePreferentialTariff(payload);
      } else {
        await this.createPreferentialTariff(payload);
      }
    },

    async createPreferentialTariff(payload) {
      this.loader = true;

      try {
        const data = await createPreferentialTariff(payload);

        if (data.success && data.payload?.id) {
          this.$router.push({
            name: "benefit_item_view",
            params: { id: data.payload.id },
          });
        }
      } finally {
        this.loader = false;
      }
    },
    async updatePreferentialTariff(payload) {
      this.loader = true;

      try {
        const data = await updatePreferentialTariff(this.uuid, payload);

        if (data.success) {
          this.$router.push({
            name: "benefit_item_view",
            params: { id: this.uuid },
          });
        }
      } finally {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  @apply h-10 flex justify-center items-center p-4 bg-card border;
  @apply border-border rounded outline-none;
  &:active {
    transform: scale(0.98);
  }
}

.menu {
  @apply w-[282px] flex flex-col p-2 gap-2 bg-card rounded-xl outline outline-1 outline-offset-[-1px];
}

.item {
  @apply flex items-center px-3 py-2 gap-3 rounded-lg cursor-pointer transition-colors;
  svg {
    @apply text-foreground;
    &.danger {
      @apply text-red-400;
    }
  }

  span {
    @apply text-base font-medium leading-6 text-foreground;
    &.danger {
      @apply text-red-400;
    }
  }
}
</style>
